import type { Location } from '@cobliteam/api-lib';
import type { DeviceDTO, DriverDTO, EventSeverity, SafetyReviewDismissReason, VehicleDTOV2, VehicleSize } from '@cobliteam/common-types';

export enum SafetyEventType {
  FAST_ACCELERATION = 'FAST_ACCELERATION',
  HARD_BREAK = 'HARD_BREAK',
  SPEEDY_TURN = 'SPEEDY_TURN',
  DISTRACTED_DRIVING = 'DISTRACTED_DRIVING',
  TAILGATING = 'TAILGATING',
  YAWN = 'YAWN',
  EYES_CLOSED = 'EYES_CLOSED',
  PHONE_USAGE = 'PHONE_USAGE',
  SMOKING = 'SMOKING',
  IMPACT = 'IMPACT',
  SOS = 'SOS',
}

export enum SafetyReviewStatus {
  RELEVANT = 'RELEVANT',
  DISMISSED = 'DISMISSED',
  NOT_REVIEWED = 'NOT_REVIEWED',
}

export interface BaseSafetyEventsRequest {
  startDate: string;
  endDate: string;
  driverIds?: string[];
  vehicleIds?: string[];
  vehicleGroupIds?: string[];
  vehicleSizes?: VehicleSize[];
  deviceTypes?: string[];
  tagNames?: string[];
  eventTypes?: SafetyEventType[];
  searchQuery?: string;
  sortColumn?: string;
  sortOrder?: string;
  safetyReviewStatus?: SafetyReviewStatus[];
  safetyOccurrencesIds?: string[];
  safetyReviewDismissReason?: SafetyReviewDismissReason[];
}

export interface PagedSafetyEventsRequest extends BaseSafetyEventsRequest {
  page: number;
  size: number;
}

export interface SafetyEventsReportRequest extends BaseSafetyEventsRequest {
  destinationEmails: string[];
}

export interface SafetyEvent {
  eventType: SafetyEventType;
  eventTime: string;
  eventLocation?: Location;
  safetyReviewStatus: SafetyReviewStatus | null;
  safetyOccurrences: string[];
  safetyReviewDismissReason?: SafetyReviewDismissReason;
  eventMediaId?: string;
  eventSeverity?: EventSeverity;
  vehicle: VehicleDTOV2;
  driver?: DriverDTO;
  device: DeviceDTO;
}

export interface SafetyEventsResponse {
  count: number;
  rows: SafetyEvent[];
  lastRankUpdate: string;
  averageFleetScore: number;
  classifiedCount: number;
}
